export const questions = [
  {
    id: "routesPerMonth",
    label: "Número de rutas por mes:",
    question: "¿Cuántas rutas planeas crear por mes?",
    type: "select",
    options: [
      { value: "1-3", label: "1-3 rutas" },
      { value: "4-7", label: "4-7 rutas" },
      { value: "8-12", label: "8-12 rutas" },
      { value: "13+", label: "13 o más rutas" },
    ],
  },
  {
    id: "achievementType",
    label: "Tipo de logros:",
    question: "¿Qué tipo de logros te interesan más?",
    type: "select",
    options: [
      { value: "progreso", label: "Seguimiento de progreso" },
      { value: "competicion", label: "Logros competitivos" },
      { value: "social", label: "Logros sociales/compartidos" },
      { value: "ninguno", label: "No me interesan los logros" },
    ],
  },
  {
    id: "mainGoal",
    label: "Objetivo principal:",
    question: "¿Cuál es tu principal objetivo en el running?",
    type: "select",
    options: [
      { value: "salud", label: "Mejorar mi salud" },
      { value: "peso", label: "Control de peso" },
      { value: "competir", label: "Competir en carreras" },
      { value: "social", label: "Actividad social" },
      { value: "estres", label: "Reducir estrés" },
    ],
  },
  {
    id: "trainingDays",
    label: "Días de entrenamiento:",
    question: "¿Cuántos días a la semana planeas entrenar?",
    type: "select",
    options: [
      { value: "1-2", label: "1-2 días" },
      { value: "3-4", label: "3-4 días" },
      { value: "5+", label: "5 o más días" },
    ],
  },
  {
    id: "activityLevel",
    label: "Nivel de actividad:",
    question: "¿Cómo describirías tu nivel de actividad física?",
    type: "select",
    options: [
      { value: "principiante", label: "Principiante" },
      { value: "intermedio", label: "Intermedio" },
      { value: "avanzado", label: "Avanzado" },
      { value: "elite", label: "Élite/Competitivo" },
    ],
  },
  {
    id: "customRoutes",
    label: "Rutas personalizadas:",
    question: "¿Cuántas rutas personalizadas quieres crear al mes?",
    type: "select",
    options: [
      { value: "0-2", label: "0-2 rutas" },
      { value: "3-5", label: "3-5 rutas" },
      { value: "6-10", label: "6-10 rutas" },
      { value: "10+", label: "Más de 10 rutas" },
    ],
  },
];
